const actions = {
    /* Fields */
    FIELD_SET: 'FIELD_SET',
    FIELD_CREATE_REQUEST: 'FIELD_CREATE_REQUEST',
    FIELD_CREATE_SUCCESS: 'FIELD_CREATE_SUCCESS',
    FIELD_CREATE_FAIL: 'FIELD_CREATE_FAIL',
    FIELD_READ_LIST_REQUEST: 'FIELD_READ_LIST_REQUEST',
    FIELD_READ_LIST_SUCCESS: 'FIELD_READ_LIST_SUCCESS',
    FIELD_READ_LIST_FAIL: 'FIELD_READ_LIST_FAIL',
    FIELD_READ_REQUEST: 'FIELD_READ_REQUEST',
    FIELD_READ_SUCCESS: 'FIELD_READ_SUCCESS',
    FIELD_READ_FAIL: 'FIELD_READ_FAIL',
    FIELD_UPDATE_REQUEST: 'FIELD_UPDATE_REQUEST',
    FIELD_UPDATE_SUCCESS: 'FIELD_UPDATE_SUCCESS',
    FIELD_UPDATE_FAIL: 'FIELD_UPDATE_FAIL',
    FIELD_DELETE_REQUEST: 'FIELD_DELETE_REQUEST',
    FIELD_DELETE_SUCCESS: 'FIELD_DELETE_SUCCESS',
    FIELD_DELETE_FAIL: 'FIELD_DELETE_FAIL',
    /* OTHERS */
    FIELD_RESET_STATE: 'FIELD_RESET_STATE',

    /* FIELDS */
    setField: field => ({
        type: actions.FIELD_SET,
        field,
    }),
    createField: request => ({
        type: actions.FIELD_CREATE_REQUEST,
        request,
    }),
    readFieldList: request => ({
        type: actions.FIELD_READ_LIST_REQUEST,
        request,
    }),
    readField: id => ({
        type: actions.FIELD_READ_REQUEST,
        id,
    }),
    updateField: (id, request) => ({
        type: actions.FIELD_UPDATE_REQUEST,
        id,
        request,
    }),
    deleteField: id => ({
        type: actions.FIELD_DELETE_REQUEST,
        id,
    }),

    /* OTHERS */
    resetState: () => ({
        type: actions.FIELD_RESET_STATE,
    }),
};
export default actions;
